// Author thq
// Date 2022-03-02 15:01:59

class EmLocation {
constructor({
        id = null,
        code = '',
        name = '',
        locIpScope = '',
        parentId = '',
        externalId = '',
        description = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.locIpScope = locIpScope;
    this.parentId = parentId;
    this.externalId = externalId;
    this.description = description;
}
}

function newEntity() {
return new EmLocation();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.em.archive.emLocation.grid.code',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'name',
        label: 'label.em.archive.emLocation.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'parentName',
        label: 'label.em.archive.emLocation.grid.parentName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'locIpScope',
        label: 'label.em.archive.emLocation.grid.locIpScope',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'level',
        label: 'label.em.archive.emLocation.grid.level',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.archive.emLocation.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'seq',
        label: 'label.em.archive.emLocation.grid.seq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'externalId',
        label: 'label.em.archive.emLocation.grid.externalId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'description',
        label: 'label.em.archive.emLocation.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    nameFilter : '',
    codeFilter : '',
    parentNameFilter : '',
    locIpScopeFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    externalIdFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.archive.emLocation.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.archive.emLocation.filter.code',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'parentNameFilter',
        label: 'label.em.archive.emLocation.filter.parentName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'locIpScopeFilter',
        label: 'label.em.archive.emLocation.filter.locIpScope',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.archive.emLocation.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.em.archive.emLocation.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'locIpScope',
        label: 'label.em.archive.emLocation.entity.locIpScope',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'parentId',
        label: 'label.em.archive.emLocation.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'externalId',
        label: 'label.em.archive.emLocation.entity.externalId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'description',
        label: 'label.em.archive.emLocation.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmLocation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
